import React, { Component } from 'react';
import { connect } from 'react-redux';
import './updateProfile.scss';
import { Button, message } from 'antd';
import NoImage from "../../../images/no-image.jpg";
import EditIcon from "../../../images/edit-icon.png";
import { saveEducationalQualification, uploadEducationalQualification, deleteEducationalQualification } from '../action/user.actions'
import { fromValidate } from '../../../helpers';
import _ from 'lodash';
import { Table, Modal } from 'antd';
import { imageEndpoint } from '../../../services/endpoint';


class EducationDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      educational_qualification: {
        qualification: '',
        degree_name: '',
        subject_of_specialization: '',
        institute_name: '',
        board: '',
        grade: '',
        location: '',
        passing_year: '',
        passing_month: '',
        achievements: ''
      },
      document: {},
      formError:{},
      visibleEducation: false,
      trainingColumns: [
        {
          title: 'Qualification',
          dataIndex: 'qualification',
        },
        {
          title: 'Degree',
          dataIndex: 'degree_name',
        },
        {
          title: 'Grade',
          dataIndex: 'grade',
        },
        {
          title: 'Passing Year',
          dataIndex: 'passing_year',
        },
        {
          title: 'Actions',
          dataIndex: '',
          render: (text, obj) => <div className='action'>
            <span onClick={() => { this.onEditEducation(obj) }}>Edit</span>
            <span onClick={() => { this.onDeleteEducation(obj) }}>Delete</span>
          </div>
        },
      ]
    }
  }

  componentDidMount() {
  }

  onEditEducation = (obj) => {

    this.setState({
      educational_qualification: obj,
      document: {},
      visibleEducation: true
    })
  }
  onDeleteEducation = (obj) => {
    const { user, dispatch } = this.props;
    dispatch(deleteEducationalQualification(user.id, obj.id));
  }

  handleChange = (e) => {
    const educational_qualification = Object.assign({}, this.state.educational_qualification)
    const name = e.target.name;
    const value = e.target.value;
    educational_qualification[name] = value;
    this.setState({ educational_qualification });
  }

  createFormData = (body) => {
    let data = new FormData();
    Object.keys(body).forEach(key => {
      data.append(key, body[key]);
    });
    return data;
  };

  onSelectFile = (e) => {
    const { user } = this.props;
    const document = Object.assign({}, this.state.document)
    let file = e.target.files[0];
    if (file) {
      document.photo = file;
      document.user_id = user.id;
      document.document_type = file.type;
      document.document_name = document.document_name || 'Certificate';
      this.setState({ document: document })
    }
    // dispatch(uploadIdentityverification(user.id, formData))
  }

  onSelectDocumentName = (e) => {
    const document = Object.assign({}, this.state.document);
    document.document_name = e.target.value;
    this.setState({ document: document })
  }



  handleOkEducation = e => {
    const { user, dispatch } = this.props;
    let { educational_qualification, document } = this.state;
    e.preventDefault();
    this.setState({ formError: {}, formSubmit: true })
    const formValidation = fromValidate(this.fromNode);
    if (!formValidation.valid) {
      this.setState({ formError: formValidation.invalidationEle })
    }
    else {
      educational_qualification.user_id = user.id;
      dispatch(saveEducationalQualification(user.id, educational_qualification))
        .then((res) => {

          if (document && document.photo) {
            const newdata = res.educational_qualification.find((qul) => {
              return qul.qualification == educational_qualification.qualification && qul.degree_name == educational_qualification.degree_name
            })
            let fromData = this.createFormData(document)
            dispatch(uploadEducationalQualification(user.id, fromData, newdata.id))
          }
          this.handleCancelEducation();
        });
    }
  };

  showModalEducation = () => {
    this.setState({
      educational_qualification: {
        qualification: '',
        degree_name: '',
        subject_of_specialization: '',
        institute_name: '',
        board: '',
        grade: '',
        location: '',
        passing_year: '',
        passing_month: '',
        achievements: ''
      },
      document: {},
      formError:{},
      visibleEducation: true
    });
  };

  handleCancelEducation = e => {
    console.log(e);
    this.setState({
      educational_qualification: {
        qualification: '',
        degree_name: '',
        subject_of_specialization: '',
        institute_name: '',
        board: '',
        grade: '',
        location: '',
        passing_year: '',
        passing_month: '',
        achievements: ''
      },
      document: {},
      formError:{},
      visibleEducation: false
    });
  };


  render() {
    const { user } = this.props;
    const { educational_qualification, trainingColumns, formError } = this.state;
    const document = (educational_qualification && educational_qualification.documents) || [];
    const doc = _.first(document);

    return (
      <div className="form-main-cont-box">
        <div className="upprof-heading-txt">Educational Detail</div>


        <div className="">
          <div>
            <Button className='btn-added-right' onClick={this.showModalEducation}>
              Add Education
						</Button>
          </div>
          <Table
            columns={trainingColumns}
            dataSource={user.educational_qualification || []}
          />

          <Modal
            title="Education Qulalification"
            visible={this.state.visibleEducation}
            onOk={this.handleOkEducation}
            onCancel={this.handleCancelEducation}
          >
            <div className="">
              <form ref={node => this.fromNode = node} noValidate autoComplete="off">
                <div className="row row-padding">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-sm-12 col-md-6 col-xs-12">
                        <input
                          required
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Qualification"
                          name="qualification"
                          value={educational_qualification.qualification}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                        {formError && formError['qualification'] && <div className="error-msg">Required</div>}
                      </div>
                      <div className="col-sm-12 col-md-6 col-xs-12">
                        <input
                          required
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Digree"
                          name="degree_name"
                          value={educational_qualification.degree_name}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                        {formError && formError['degree_name'] && <div className="error-msg">Required</div>}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12 col-md-6 col-xs-12">
                        <input
                          required
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Specialization"
                          name="subject_of_specialization"
                          value={educational_qualification.subject_of_specialization}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                         {formError && formError['subject_of_specialization'] && <div className="error-msg">Required</div>}
                      </div>
                      <div className="col-sm-12 col-md-6 col-xs-12">
                        <input
                          required
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Institute"
                          name="institute_name"
                          value={educational_qualification.institute_name}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                         {formError && formError['institute_name'] && <div className="error-msg">Required</div>}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12 col-md-6 col-xs-12">
                        <input
                          required
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Board"
                          name="board"
                          value={educational_qualification.board}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                         {formError && formError['board'] && <div className="error-msg">Required</div>}
                      </div>
                      <div className="col-sm-12 col-md-6 col-xs-12">
                        <input
                          required
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Grade"
                          name="grade"
                          value={educational_qualification.grade}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <input
                          required
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Location"
                          name="location"
                          value={educational_qualification.location}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                        {formError && formError['location'] && <div className="error-msg">Required</div>}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12 col-md-6 col-xs-12">
                        <input
                          required
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Passing Year"
                          name="passing_year"
                          value={educational_qualification.passing_year}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                        {formError && formError['passing_year'] && <div className="error-msg">Required</div>}
                      </div>
                      <div className="col-sm-12 col-md-6 col-xs-12">
                        <input
                          required
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Passing Month"
                          name="passing_month"
                          value={educational_qualification.passing_month}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                        {formError && formError['passing_month'] && <div className="error-msg">Required</div>}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12">
                        <input
                          required
                          type="text"
                          className='prof-textfield-containt'
                          placeholder="Achievements"
                          name="achievements"
                          value={educational_qualification.achievements}
                          onChange={(e) => { this.handleChange(e) }}
                        />
                        {formError && formError['achievements'] && <div className="error-msg">Required</div>}
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div>
                      <div className="doc-img-box">
                        <div className="upload-btn-wrapper">
                          <img src={EditIcon} className="doc-edit-icon" alt="" />
                          <input type="file" name="myfile" onChange={(e) => { this.onSelectFile(e) }} />
                        </div>
                        <img src={doc && doc.document_url ? imageEndpoint + doc.document_url : NoImage} className="update-prof-img-box" alt="" />
                      </div>
                      <label className="redio-lavel-txt" >Upload Document</label>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </Modal>
        </div>

      </div>
    )
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  }
}
export default connect(mapStateToProps)(EducationDetail);